import { pushSupport } from "./push-subscription";

export const PROMPT_SHOWN_KEY = "split-it:push-prompt-shown";

export const isPromptShown = (storage = window.localStorage) => {
  try {
    return storage.getItem(PROMPT_SHOWN_KEY) !== null;
  } catch (error) {
    return true;
  }
};

export const markPromptShown = (storage = window.localStorage) => {
  try {
    storage.setItem(PROMPT_SHOWN_KEY, new Date().toISOString());
  } catch (error) {}
};

export const shouldOfferPushPrompt = ({
  support,
  permission,
  subscribed,
  serverEnabled,
  hasWorker,
  online,
  alreadyShown,
}) =>
  support === pushSupport.supported &&
  permission === "default" &&
  !subscribed &&
  serverEnabled &&
  hasWorker &&
  online &&
  !alreadyShown;
